export const formatNumber = (number) => new Intl.NumberFormat().format(number);
export const positiveNumberOrNull = (val) => val < 0 ? null : val;